// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__0hj5I","done":"StatusChip_done__o4pE3","next":"StatusChip_next__E5oaO","locked":"StatusChip_locked__0R0sC","finish":"StatusChip_finish__MlTi4"};